import { Button } from "devextreme-react";
import React, { useEffect } from "react";

import Header from "../../common/Header";
import MedicalDeviceDataGrid from "../MedicalDeviceDataGrid";

function HospitalLink({ data }) {
  return (
    <Button
      icon="home"
      disabled={!data.hospUrl}
      onClick={() => window.open(data.hospUrl, "_blank", "noopener,noreferrer")}
    />
  );
}

const columns = [
  { dataField: "MEDC_INST_NM", caption: "실시기관명", dataType: "string", width: 260 },
  { dataField: "CLST_INST_DSGN_NO", caption: "임상시험기관 지정번호", dataType: "string" },
  { dataField: "CLST_DSGN_DT", caption: "지정일", dataType: "date", format: "yyyy-MM-dd", width: 120 },
  { dataField: "MEDC_HDINS_NM", caption: "기관장", dataType: "string" },
  { dataField: "MEDC_INST_CLSFY_DIVS_CD", caption: "의료기관 분류", dataType: "string" },
  { dataField: "MEDC_INST_DIVS_CD", caption: "의료기관 구분", dataType: "string" },
  { dataField: "CARE_INST_DSGN_DIVS_CD", caption: "의료급여기관 구분", dataType: "string" },
  { dataField: "IRB_DIVS_CD", caption: "IRB 구분", dataType: "string", width: 260 },
  { dataField: "DSPN_DIVS_CD", caption: "처분 구분", dataType: "string" },
  { dataField: "SIDO", caption: "시·도", dataType: "string" },
  { dataField: "INST_ZIPNO", caption: "우편번호", dataType: "string" },
  { dataField: "MACHINERY_ADDR1", caption: "주소", dataType: "string", width: 320 },
  { dataField: "MACHINERY_ADDR2", caption: "상세주소", dataType: "string", width: 260 },
  { dataField: "MDEM_DPTM_INFO", caption: "의료기기 담당부서 정보", dataType: "string", width: 300 },
  { dataField: "hospUrl", caption: "병원 정보", cellRender: HospitalLink, allowFiltering: false, allowHeaderFiltering: false, allowSorting: false, width: 90 },
];

export default function MedicalDeviceInstitutions() {
  useEffect(() => {
    document.title = "의료기기 임상시험 실시기관 정보";
  }, []);

  return (
    <>
      <Header title="MEDICAL DEVICE CLINICAL TRIAL INSTITUTION INFO." menuDataSource={null} />
      <hr style={{ border: "0.5px solid #e0e0e0" }} />
      <MedicalDeviceDataGrid
        endpoint="/api/medical-device/institutions"
        keyExpr="CLST_INST_SEQ"
        columns={columns}
        storageKey="MedicalDeviceInstitutions"
        exportTitle="식품의약품안전처_의료기기 임상시험 실시기관 정보"
      />
    </>
  );
}
